// extracted by mini-css-extract-plugin
module.exports = {"addNewBtn":"AddNewGuest_addNewBtn__znm6_","addNewDesc":"AddNewGuest_addNewDesc__2eExB","actionsMenu":"AddNewGuest_actionsMenu__1Fz8l","option":"AddNewGuest_option__2aUfc"};